import React, { useState, useEffect } from "react";
import { Text } from "components";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import { AgGridReact } from "ag-grid-react"; // React Grid Logic
import "ag-grid-community/styles/ag-grid.css"; // Core CSS
import "ag-grid-community/styles/ag-theme-quartz.css";
import { useFormik } from "formik";
import * as Yup from "yup";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import AccessRightCard from "pages/AccessRight/AccessRightCard";
pdfMake.vfs = pdfFonts.pdfMake?.vfs;

const DetailrevenueReports = () => {
  const [hospitalBuissnessReport, setHospitalBuissnessReport] = useState([]);
  const [
    hospitalBuissnessFeeDistributionReport,
    setHospitalBuissnessFeeDistributionReport,
  ] = useState([]);
  const [
    hospitalBuissnessPaymentTypeReport,
    setHospitalBuissnessPaymentTypeReport,
  ] = useState([]);
  const [
    hospitalBuissnessUserDetailDetailed,
    setHospitalBuissnessUserDetailDetailed,
  ] = useState([]);
  const [userList, setuserlist] = useState([]);
  const [filterAppointment, setFilterAppointment] = useState([]);
  const [pdfexportflag, setpdfexportflag] = useState(false);
  const [repotType, setReportType] = useState([
    { id: 1, name: "Detailed Business Report" },
    { id: 2, name: "Detailed Item-Wise Business Report" },
    { id: 3, name: "Detailed Payment Mode-wise Business Report" },
    { id: 4, name: "Detailed Consultant Business Report" },
  ]);
  const [reportTypeId, setReportTypeId] = useState();
  const token = sessionStorage.getItem("token");
  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const [doclist, setdoclist] = useState([]);
  useEffect(() => {
    // Retrieving data from sessionStorage
    const storeddoclist = sessionStorage.getItem("docAccesslist");

    if (storeddoclist) {
      try {
        // Parsing the JSON string to an array of objects
        const parseddoclist = JSON.parse(storeddoclist);
        setdoclist(parseddoclist);
      } catch (error) {
        console.error("Error parsing JSON:", error);
      }
    }
  }, []);
  const showActionColumn = doclist.some(
    (item) => item.hospital_module_id == 24 && item.view,
  );

  const validationSchema = Yup.object().shape({
    from_date: Yup.string().required("Start Date is required"),
    to_date: Yup.date()
      .required("End Date is required")
      .max(new Date(), "End Date cannot be in the future"),
    report_type_id: Yup.string().required("Report Type is required"),
    // userdetail_id: Yup.string().required("Consaltant is required"),
  });
  // for initializing the start date and end date
  const today = new Date();
  const firstDay = new Date(today.getFullYear(), today.getMonth(), 2);
  const formatDate = (date) => date.toISOString().split("T")[0];
  const formik = useFormik({
    initialValues: {
      from_date: formatDate(firstDay),
      to_date:formatDate(today),
      userdetail_id: "",
      report_type_id: "",
    },
    validationSchema: validationSchema,
  });
  useEffect(() => {
    getAllConsultant();
    if (reportTypeId == 1) {
      getHospitalBuissnessReport();
    } else if (reportTypeId == 2) {
      getHospitalBuissnessFeeDistributionReport();
    } else if (reportTypeId == 3) {
      getHospitalBuissnessPaymentTypeReport();
    } else if (reportTypeId == 4) {
      getHospitalBuissnessUserDetailDetailed();
    }
  }, []);

  //for cunsultatnt list

  const getAllConsultant = () => {
    axios
      .post("/api/doctor/userdetail/getAll", {}, headers)
      .then((response) => {
        const filteruserlist = response.data.filter(
          (user) => user.user_type_id === 2,
        );
        setuserlist(filteruserlist);
        console.log(filteruserlist);
      })
      .catch(() => {
        console.log("Error");
      });
  };

  // for reportTypeId=1

  const getHospitalBuissnessReport = (from_date, to_date, userId) => {
    if (from_date != "" && to_date != "" && userId !== 0) {
      axios
        .post(
          "/api/doctor/report/hospital/buissness/get",
          { from_date: from_date, to_date: to_date, userdetail_id: userId },
          headers,
        )
        .then((response) => {
          setHospitalBuissnessReport(response.data);
          console.log(response.data);
        })
        .catch(() => {
          console.log("Error");
        });
    }
  };

  //for Report Type Id =2
  const getHospitalBuissnessFeeDistributionReport = (
    from_date,
    to_date,
    userId,
  ) => {
    if (from_date != "" && to_date != "" && userId !== 0) {
      axios
        .post(
          "/api/doctor/report/hospital/fee_distribution/buissness/get",
          { from_date: from_date, to_date: to_date, userdetail_id: userId },
          headers,
        )
        .then((response) => {
          setHospitalBuissnessFeeDistributionReport(response.data);
          console.log(response.data);
        })
        .catch(() => {
          console.log("Error");
        });
    }
  };

  //FOR REPORTTYPEID==3
  const getHospitalBuissnessPaymentTypeReport = (
    from_date,
    to_date,
    userId,
  ) => {
    if (from_date != "" && to_date != "" && userId !== 0) {
      axios
        .post(
          "/api/doctor/report/hospital/payment_type/buissness/get",
          { from_date: from_date, to_date: to_date, userdetail_id: userId },
          headers,
        )
        .then((response) => {
          setHospitalBuissnessPaymentTypeReport(response.data);
          console.log(response.data);
        })
        .catch(() => {
          console.log("Error");
        });
    }
  };

  //FOR REPORTTYPEID==4
  const getHospitalBuissnessUserDetailDetailed = (
    from_date,
    to_date,
    userId,
  ) => {
    if (from_date != "" && to_date != "" && userId !== 0) {
      axios
        .post(
          "/api/doctor/report/hospital/user_detail/detailed/buissness/get",
          { from_date: from_date, to_date: to_date, userdetail_id: userId },
          headers,
        )
        .then((response) => {
          setHospitalBuissnessUserDetailDetailed(response.data);
          console.log(response.data);
        })
        .catch(() => {
          console.log("Error");
        });
    }
  };

  //for reporttypeid=1

  const [colDefsForReportId1, setcolDefsForReportId1] = useState([
    { headerName: "Sr.No.", field: "sr", width: 85 ,minWidth: 75,},
    {
      headerName: "CONSULTANT",
      field: "name",
      width: 150,
      minWidth: 100,
      flex: 1,
      
    },
    {
      headerName: "FROM DATE",
      field: "from_date",
      width: 120,
      minWidth: 100,
    },
    {
      headerName: "TO DATE",
      field: "to_date",
      width: 120,
      minWidth: 100,
    },
    {
      headerName: "TOTAL AMOUNT (Rs)",
      field: "total_fee",
      minWidth: 120,
      flex: 1,
      
    },
    {
      headerName: "TOTAL RECEIVED (Rs)",
      field: "received_fee",
      minWidth: 120,
      flex: 1,
      
    },
    {
      headerName: "TOTAL PENDING (Rs)",
      field: "pending_fee",
      width: 170,
      minWidth: 120,
      pinned: "right"
    },
  ]);

  //for report type id =2
  const [colDefsForReportId2, setcolDefsForReportId2] = useState([
    { headerName: "SNO.", field: "sr", width: 85 ,minWidth: 75, },
    {
      headerName: "DOCTOR NAME",
      field: "name",
      minWidth: 120,
      flex: 1,
    },
    {
      headerName: "PROCEDURE NAME",
      field: "fee_type_name",
      minWidth: 120,
      flex: 1,
    },
    {
      headerName: "FROM DATE",
      field: "from_date",
      width: 120,
      minWidth: 100,
    },
    {
      headerName: "TO DATE",
      field: "to_date",
      width: 120,
      minWidth: 100,
    },
    {
      headerName: "TOTAL AMOUNT (Rs)",
      field: "total_fee",
      width: 170,
      minWidth: 120,
      pinned: "right"
    },
  ]);

  //for reportTypeId ==3

  const [colDefsForReportId3, setcolDefsForReportId3] = useState([
    { headerName: "SNO.", field: "sr", width: 85 , minWidth: 75, },
    {
      headerName: "DOCTOR NAME",
      field: "name",
      minWidth: 120,
      flex: 1,
    },
    {
      headerName: "PAYMENT NAME",
      field: "payment_type_name",
      minWidth: 120,
      flex: 1,
    },
    {
      headerName: "FROM DATE",
      field: "from_date",
      width: 120,
      minWidth: 100,
    },
    {
      headerName: "TO DATE",
      field: "to_date",
      width: 120,
      minWidth: 100,
    },
    {
      headerName: "TOTAL AMOUNT (Rs)",
      field: "total_fee",
      width: 150,
      minWidth: 120,
      pinned: "right"
    },
  ]);

  // reporttypeid==4
  const [colDefsForReportId4, setcolDefsForReportId4] = useState([
    { headerName: "SNO.", field: "sr", width: 85 ,minWidth: 75, },
    {
      headerName: "DOCTOR NAME",
      field: "name",
      minWidth: 120,
      
    },
    {
      headerName: "PATIENT NAME",
      field: "fullname",
      minWidth: 120,
    },
    {
      headerName: "Slot DATE",
      field: "slot_date",
      minWidth: 100,
    },

    {
      headerName: "TOTAL AMOUNT (Rs)",
      field: "total_fee",
      minWidth: 120,
      flex: 1,
    },
    {
      headerName: "TOTAL RECEIVED (Rs)",
      field: "received_fee",
      minWidth: 120,
      flex: 1,
    },
    {
      headerName: "TOTAL PENDING (Rs)",
      field: "pending_fee",
      width: 150,
      minWidth: 120,
      pinned: "right"
    },
  ]);

  //for converting url using Base64

  function getBase64ImageFromURL(url) {
    return new Promise((resolve, reject) => {
      var img = new Image();
      img.setAttribute("crossOrigin", "anonymous");

      img.onload = () => {
        var canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;

        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);

        var dataURL = canvas.toDataURL("image/png");

        resolve(dataURL);
      };

      img.onerror = (error) => {
        reject(error);
      };

      img.src = url;
    });
  }

  const DownloadPDF1 = async () => {
    let totalSum = 0;
    let totalReceived = 0;
    let totalPanding = 0;
    for (let i = 0; i < hospitalBuissnessReport.length; i++) {
      totalSum = totalSum + hospitalBuissnessReport[i].total_fee;
      totalReceived = totalPanding + hospitalBuissnessReport[i].received_fee;
      totalPanding = totalPanding + hospitalBuissnessReport[i].pending_fee;
    }
    const docDefinition = {
      pageOrientation: "portrait",
      header: {},

      content: [
        { text: "", margin: [0, 10] },

        {
          text: "Detailed Buissness Report",
          margin: [0, 10],
          alignment: "center",
        },
        {
          // Add the line here
          canvas: [
            { type: "line", x1: 0, y1: 0, x2: 510.28, y2: 0, lineWidth: 0.5 },
          ],
        },
        { text: "", margin: [0, 5] },
        {
          style: "tableExample",
          table: {
            widths: [245, 250], // Set widths for each column
            body: [
              [
                [
                  {
                    text: `From Date : ${hospitalBuissnessReport[0].from_date} `,
                    style: "tableHeader",
                  },
                ],
                [
                  {
                    text: `To Date :  ${hospitalBuissnessReport[0].to_date}`,
                    style: "tableHeader",
                  },
                ],
              ],
            ],
          },
        },
        { text: "", margin: [0, 5] },

        {
          style: "tableExample",
          table: {
            widths: [90, 50, 50, 90, 90, 90], // Set widths for each column
            body: [
              [
                [{ text: "Consultant Name", style: "tableHeader" }],
                [{ text: "From Date", style: "tableHeader" }],
                [{ text: "To Date", style: "tableHeader" }],
                [{ text: "Total Amount(Rs.)", style: "tableHeader" }],
                [{ text: "Total Received(Rs.)", style: "tableHeader" }],
                [{ text: "Total Pending(Rs.)", style: "tableHeader" }],
              ],
              ...hospitalBuissnessReport.map((hospitalBuissnessReport) => [
                hospitalBuissnessReport.name,
                hospitalBuissnessReport.from_date,
                hospitalBuissnessReport.to_date,
                hospitalBuissnessReport.total_fee,
                hospitalBuissnessReport.received_fee,
                hospitalBuissnessReport.pending_fee,
              ]),
              //for total
              [
                {
                  text: "Total",
                  style: "tableHeader",
                  colSpan: 3,
                  alignment: "right",
                },
                {},
                {},
                { text: totalSum, style: "tableHeader", alignment: "left" },
                {
                  text: totalReceived,
                  style: "tableHeader",
                  alignment: "left",
                },
                { text: totalPanding, style: "tableHeader", alignment: "left" },
              ],
            ],
          },
          layout: {
            fillColor: function (rowIndex) {
              return rowIndex === 0 ? "#CCCCCC" : null;
            },
          },
        },
      ],
      styles: {
        tableExample: {
          fontSize: 8, // Set the font size to a smaller value
          // color: "#333",
        },
        tableHeader: {
          bold: true,
          fontSize: 10, // You can set a different font size for headers if needed
        },
        header: {
          fontSize: 18,
          bold: true,
          margin: [10, 10, 10, 20],
        },
      },
    };
    pdfMake
      .createPdf(docDefinition)
      .download("Bill Item-wise Business Summary Report");
  };

  const DownloadPDF2 = async () => {
    let totalSum = 0;

    for (let i = 0; i < hospitalBuissnessFeeDistributionReport.length; i++) {
      totalSum = totalSum + hospitalBuissnessFeeDistributionReport[i].total_fee;
    }
    const docDefinition = {
      pageOrientation: "portrait",
      header: {},

      content: [
        { text: "", margin: [0, 10] },

        {
          text: "Detailed Item-wise Buissness Report",
          margin: [0, 10],
          alignment: "center",
        },
        {
          // Add the line here
          canvas: [
            { type: "line", x1: 0, y1: 0, x2: 510.28, y2: 0, lineWidth: 0.5 },
          ],
        },
        { text: "", margin: [0, 5] },
        {
          style: "tableExample",
          table: {
            widths: [245, 250], // Set widths for each column
            body: [
              [
                [
                  {
                    text: `From Date : ${hospitalBuissnessFeeDistributionReport[0].from_date} `,
                    style: "tableHeader",
                  },
                ],
                [
                  {
                    text: `To Date :  ${hospitalBuissnessFeeDistributionReport[0].to_date}`,
                    style: "tableHeader",
                  },
                ],
              ],
            ],
          },
        },
        { text: "", margin: [0, 5] },

        {
          style: "tableExample",
          table: {
            widths: [110, 90, 90, 90, 90, 90], // Set widths for each column
            body: [
              [
                [{ text: "Consultant Name", style: "tableHeader" }],
                [{ text: "Procedure Name", style: "tableHeader" }],
                [{ text: "From Date", style: "tableHeader" }],
                [{ text: "To Date", style: "tableHeader" }],
                [{ text: "Total Amount(Rs.)", style: "tableHeader" }],
              ],
              ...hospitalBuissnessFeeDistributionReport.map(
                (hospitalBuissnessFeeDistributionReport) => [
                  hospitalBuissnessFeeDistributionReport.name,
                  hospitalBuissnessFeeDistributionReport.fee_type_name,
                  hospitalBuissnessFeeDistributionReport.from_date,
                  hospitalBuissnessFeeDistributionReport.to_date,
                  hospitalBuissnessFeeDistributionReport.total_fee,
                ],
              ),
              //for total
              [
                {
                  text: "Total",
                  style: "tableHeader",
                  colSpan: 4,
                  alignment: "right",
                },
                {},
                {},
                {},
                { text: totalSum, style: "tableHeader", alignment: "left" },
              ],
            ],
          },
          layout: {
            fillColor: function (rowIndex) {
              return rowIndex === 0 ? "#CCCCCC" : null;
            },
          },
        },
      ],
      styles: {
        tableExample: {
          fontSize: 8, // Set the font size to a smaller value
          // color: "#333",
        },
        tableHeader: {
          bold: true,
          fontSize: 10, // You can set a different font size for headers if needed
        },
        header: {
          fontSize: 18,
          bold: true,
          margin: [10, 10, 10, 20],
        },
      },
    };
    pdfMake
      .createPdf(docDefinition)
      .download("Bill Item-wise Business Summary Report");
  };

  //reportTypeid==3

  const DownloadPDF3 = async () => {
    let totalSum = 0;

    for (let i = 0; i < hospitalBuissnessPaymentTypeReport.length; i++) {
      totalSum = totalSum + hospitalBuissnessPaymentTypeReport[i].total_fee;
    }
    const docDefinition = {
      pageOrientation: "portrait",
      header: {},

      content: [
        { text: "", margin: [0, 10] },

        {
          text: "Detailed Payment Mode-wise Buissness Report",
          margin: [0, 10],
          alignment: "center",
        },
        {
          // Add the line here
          canvas: [
            { type: "line", x1: 0, y1: 0, x2: 510.28, y2: 0, lineWidth: 0.5 },
          ],
        },
        { text: "", margin: [0, 5] },
        {
          style: "tableExample",
          table: {
            widths: [245, 250], // Set widths for each column
            body: [
              [
                [
                  {
                    text: `From Date : ${hospitalBuissnessPaymentTypeReport[0].from_date} `,
                    style: "tableHeader",
                  },
                ],
                [
                  {
                    text: `To Date :  ${hospitalBuissnessPaymentTypeReport[0].to_date}`,
                    style: "tableHeader",
                  },
                ],
              ],
            ],
          },
        },
        { text: "", margin: [0, 5] },

        {
          style: "tableExample",
          table: {
            widths: [110, 90, 90, 90, 90, 90], // Set widths for each column
            body: [
              [
                [{ text: "Consultant Name", style: "tableHeader" }],
                [{ text: "Procedure Name", style: "tableHeader" }],
                [{ text: "From Date", style: "tableHeader" }],
                [{ text: "To Date", style: "tableHeader" }],
                [{ text: "Total Amount(Rs.)", style: "tableHeader" }],
              ],
              ...hospitalBuissnessPaymentTypeReport.map(
                (hospitalBuissnessPaymentTypeReport) => [
                  hospitalBuissnessPaymentTypeReport.name,
                  hospitalBuissnessPaymentTypeReport.payment_type_name,
                  hospitalBuissnessPaymentTypeReport.from_date,
                  hospitalBuissnessPaymentTypeReport.to_date,
                  hospitalBuissnessPaymentTypeReport.total_fee,
                ],
              ),
              //for total
              [
                {
                  text: "Total",
                  style: "tableHeader",
                  colSpan: 4,
                  alignment: "right",
                },
                {},
                {},
                {},
                { text: totalSum, style: "tableHeader", alignment: "left" },
              ],
            ],
          },
          layout: {
            fillColor: function (rowIndex) {
              return rowIndex === 0 ? "#CCCCCC" : null;
            },
          },
        },
      ],
      styles: {
        tableExample: {
          fontSize: 8, // Set the font size to a smaller value
          // color: "#333",
        },
        tableHeader: {
          bold: true,
          fontSize: 10, // You can set a different font size for headers if needed
        },
        header: {
          fontSize: 18,
          bold: true,
          margin: [10, 10, 10, 20],
        },
      },
    };
    pdfMake
      .createPdf(docDefinition)
      .download("Bill Item-wise Business Summary Report");
  };

  //reportTypeId==4

  const DownloadPDF4 = async () => {
    let totalSum = 0;
    let totalReceived = 0;
    let totalPanding = 0;
    for (let i = 0; i < hospitalBuissnessUserDetailDetailed.length; i++) {
      totalSum = totalSum + hospitalBuissnessUserDetailDetailed[i].total_fee;
      totalReceived =
        totalPanding + hospitalBuissnessUserDetailDetailed[i].received_fee;
      totalPanding =
        totalPanding + hospitalBuissnessUserDetailDetailed[i].pending_fee;
    }
    const docDefinition = {
      pageOrientation: "portrait",
      header: {},

      content: [
        { text: "", margin: [0, 10] },

        {
          text: "Detailed Consultant Buissness Report",
          margin: [0, 10],
          alignment: "center",
        },
        {
          // Add the line here
          canvas: [
            { type: "line", x1: 0, y1: 0, x2: 510.28, y2: 0, lineWidth: 0.5 },
          ],
        },
        { text: "", margin: [0, 5] },
        {
          style: "tableExample",
          table: {
            widths: [245, 250], // Set widths for each column
            body: [
              [
                [
                  {
                    text: `From Date : ${formik.values.from_date} `,
                    style: "tableHeader",
                  },
                ],
                [
                  {
                    text: `To Date :  ${formik.values.to_date}`,
                    style: "tableHeader",
                  },
                ],
              ],
            ],
          },
        },
        { text: "", margin: [0, 5] },

        {
          style: "tableExample",
          table: {
            widths: [90, 50, 50, 90, 90, 90], // Set widths for each column
            body: [
              [
                [{ text: "Consultant Name", style: "tableHeader" }],
                [{ text: "Patient Name", style: "tableHeader" }],
                [{ text: "Slot Date", style: "tableHeader" }],
                [{ text: "Total Amount(Rs.)", style: "tableHeader" }],
                [{ text: "Total Received(Rs.)", style: "tableHeader" }],
                [{ text: "Total Pending(Rs.)", style: "tableHeader" }],
              ],
              ...hospitalBuissnessUserDetailDetailed.map(
                (hospitalBuissnessUserDetailDetailed) => [
                  hospitalBuissnessUserDetailDetailed.name,
                  hospitalBuissnessUserDetailDetailed.fullname,
                  hospitalBuissnessUserDetailDetailed.slot_date,
                  hospitalBuissnessUserDetailDetailed.total_fee,
                  hospitalBuissnessUserDetailDetailed.received_fee,
                  hospitalBuissnessUserDetailDetailed.pending_fee,
                ],
              ),
              //for total
              [
                {
                  text: "Total",
                  style: "tableHeader",
                  colSpan: 3,
                  alignment: "right",
                },
                {},
                {},
                { text: totalSum, style: "tableHeader", alignment: "left" },
                {
                  text: totalReceived,
                  style: "tableHeader",
                  alignment: "left",
                },
                { text: totalPanding, style: "tableHeader", alignment: "left" },
              ],
            ],
          },
          layout: {
            fillColor: function (rowIndex) {
              return rowIndex === 0 ? "#CCCCCC" : null;
            },
          },
        },
      ],
      styles: {
        tableExample: {
          fontSize: 8, // Set the font size to a smaller value
          // color: "#333",
        },
        tableHeader: {
          bold: true,
          fontSize: 10, // You can set a different font size for headers if needed
        },
        header: {
          fontSize: 18,
          bold: true,
          margin: [10, 10, 10, 20],
        },
      },
    };
    pdfMake
      .createPdf(docDefinition)
      .download("Bill Item-wise Business Summary Report");
  };

  const ColDefaultVale = { filter: true };
  const gridOptions = {
    overlayNoRowsTemplate: `
        <div id="progress-bar-id" class="flex items-center justify-center">
            <div class="animate-spin rounded-full h-12 w-12 border-t-4 border-blue-500"></div>
        </div>
    `,
  };
  const gridOptions2 = {
    overlayNoRowsTemplate: `
      <div id="progress-bar-id" class="flex items-center justify-center" style="font-size: 20px; padding: 20px;">
        <div>
          <p>No Data Found</p>
        </div>
      </div>
    `,
  };
  return (
    <>
      {showActionColumn ? (
        <div className="overflow-hidden">
          <form onSubmit={formik.handleSubmit}>
              <div className="filter-section">
                {/* start date */}
                <div>
                  <div className="filter-section-label">
                    <span >
                      Start Date
                    </span>
                    <span className="text-red-500 ">
                      *
                    </span>
                  </div>
                  <input
                    name="from_date"
                    type="date"
                    placeholder="Enter start date"
                    value={formik.values.from_date}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className="filter-section-input"
                  ></input>
                  {formik.touched.from_date && formik.errors.from_date ? (
                    <div className="form-error ">
                      {formik.errors.from_date}
                    </div>
                  ) : null}
                </div>
                  {/* end date */}
                <div>
                  <Text
                    className="filter-section-label"
                  >
                    <span >
                      End Date
                    </span>
                    <span className="text-red-500">
                      *
                    </span>
                  </Text>
                  <input
                    name="to_date"
                    type="date"
                    placeholder="Enter End Date"
                    value={formik.values.to_date}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className="filter-section-input"
                  ></input>

                  {formik.touched.to_date && formik.errors.to_date ? (
                    <div className="form-error">
                      {formik.errors.end_date}
                    </div>
                  ) : null}
                </div>
                  {/* Select Consultant */}
                <div >
                  <Text
                    className=" filter-section-label"
                  >
                    <span >
                      Select Consultant
                    </span>
                    <span className="text-red-500 font-inter font-small">
                      *
                    </span>
                  </Text>

                  <Select
                    name="userdetail_id"
                    options={[
                      { label: "All", value: "" }, // Adding the "All Consultants" option
                      ...(userList?.map((resstate) => ({
                        label: resstate.name,
                        value: resstate.id,
                      })) ?? []),
                    ]}
                    classNamePrefix="filter-custom-select"
                    onChange={(selectedOption) => {
                      formik.setFieldValue(
                        "userdetail_id",
                        selectedOption.value,
                      );
                    }}
                    onBlur={formik.handleBlur}
                    placeholder="All"
                    // styles={{
                    //     control: (base) => ({
                    //       ...base,
                    //       minHeight: "34px",
                    //       height: "35px",
                    //       width: "200px",
                    //     }),
                    //     valueContainer: (base) => ({
                    //       ...base,
                    //       height: "36px",
                    //       padding: "0 8px",
                    //     }),
                    //     indicatorsContainer: (base) => ({
                    //       ...base,
                    //       height: "36px",
                    //     }),
                    //   }}
                  />
                </div>
                {/* Select Report */}
                <div >
                  <Text
                    className=" filter-section-label"
                  >
                    <span >
                      Select Report
                    </span>
                    <span className="text-red-500 font-inter font-small">
                      *
                    </span>
                  </Text>
                  <Select
                    name="report_type_id"
                    options={repotType?.map((resstate) => ({
                      label: resstate.name,
                      value: resstate.id,
                    }))}
                    classNamePrefix="filter-custom-select"
                    onChange={(selectedOption) => {
                      formik.setFieldValue(
                        "report_type_id",
                        selectedOption.value,
                      );
                      setpdfexportflag(false);
                      setReportTypeId(selectedOption.value);
                    }}
                    onBlur={formik.handleBlur}
                    placeholder="Select Report" 
                  />
                  {formik.touched.report_type_id &&
                  formik.errors.report_type_id ? (
                    <div className="text-red-500 text-xs">
                      {formik.errors.report_type_id}
                    </div>
                  ) : null}
                </div>
                  {/* buttons */}
                <div className="button-row">
                  <button
                    type="submit"
                    id="dropdownDefaultButton"
                    className="btn-primary mt-4"
                    onClick={() => {
                      if (reportTypeId == 1) {
                        getHospitalBuissnessReport(
                          formik.values.from_date,
                          formik.values.to_date,
                          formik.values.userdetail_id,
                        );
                      } else if (reportTypeId == 2) {
                        getHospitalBuissnessFeeDistributionReport(
                          formik.values.from_date,
                          formik.values.to_date,
                          formik.values.userdetail_id,
                        );
                      } else if (reportTypeId == 3) {
                        getHospitalBuissnessPaymentTypeReport(
                          formik.values.from_date,
                          formik.values.to_date,
                          formik.values.userdetail_id,
                        );
                      } else if (reportTypeId == 4) {
                        getHospitalBuissnessUserDetailDetailed(
                          formik.values.from_date,
                          formik.values.to_date,
                          formik.values.userdetail_id,
                        );
                      }
                      setpdfexportflag(true);
                    }}
                  >
                    Generate Report
                  </button>

                  {pdfexportflag == true &&
                  (hospitalBuissnessReport.length > 0 ||
                    hospitalBuissnessFeeDistributionReport.length ||
                    hospitalBuissnessPaymentTypeReport.length > 0 ||
                    hospitalBuissnessUserDetailDetailed.length > 0) ? (
                    <button
                      type="button"
                      id="dropdownDefaultButton"
                      className="btn-secondary mb-1.5"
                      onClick={() => {
                        if (reportTypeId === 1) {
                          DownloadPDF1();
                        } else if (reportTypeId === 2) {
                          DownloadPDF2();
                        } else if (reportTypeId === 3) {
                          DownloadPDF3();
                        } else if (reportTypeId === 4) {
                          DownloadPDF4();
                        }
                      }}
                    >
                      Export To PDF
                    </button>
                  ) : null}
                </div>
              </div>
          </form>
          <ToastContainer />
          {/* <hr className="w-full border-2" /> */}
          <div  className="h-[calc(100vh-215px)]">
            <div
              className="ag-theme-quartz"
              style={{ height: "100%", width: "100%", fontSize: "12px" }}
            >
              {hospitalBuissnessReport[0]?.total_fee != null &&
                reportTypeId == 1 && (
                  <AgGridReact
                    rowData={hospitalBuissnessReport.map((orders, index) => ({
                      ...orders,
                      sr: index + 1,
                    }))}
                    columnDefs={colDefsForReportId1}
                    pagination={true}
                    defaultColDef={ColDefaultVale}
                    suppressMenuHide={true}
                    suppressExcelExport={true}
                    gridOptions={
                      filterAppointment.length < 1 ? gridOptions2 : gridOptions
                    }
                  />
                )}

              {hospitalBuissnessFeeDistributionReport[0]?.total_fee != null &&
                reportTypeId == 2 && (
                  <AgGridReact
                    rowData={hospitalBuissnessFeeDistributionReport.map(
                      (orders, index) => ({
                        ...orders,
                        sr: index + 1,
                      }),
                    )}
                    columnDefs={colDefsForReportId2}
                    pagination={true}
                    defaultColDef={ColDefaultVale}
                    suppressMenuHide={true}
                    suppressExcelExport={true}
                    gridOptions={
                      filterAppointment.length < 1 ? gridOptions2 : gridOptions
                    }
                  />
                )}

              {hospitalBuissnessPaymentTypeReport[0]?.total_fee != null &&
                reportTypeId == 3 && (
                  <AgGridReact
                    rowData={hospitalBuissnessPaymentTypeReport.map(
                      (orders, index) => ({
                        ...orders,
                        sr: index + 1,
                      }),
                    )}
                    columnDefs={colDefsForReportId3}
                    pagination={true}
                    defaultColDef={ColDefaultVale}
                    suppressMenuHide={true}
                    suppressExcelExport={true}
                    gridOptions={
                      filterAppointment.length < 1 ? gridOptions2 : gridOptions
                    }
                  />
                )}

              {hospitalBuissnessUserDetailDetailed[0]?.total_fee != null &&
                reportTypeId == 4 && (
                  <AgGridReact
                    rowData={hospitalBuissnessUserDetailDetailed.map(
                      (orders, index) => ({
                        ...orders,
                        sr: index + 1,
                      }),
                    )}
                    columnDefs={colDefsForReportId4}
                    pagination={true}
                    defaultColDef={ColDefaultVale}
                    suppressMenuHide={true}
                    suppressExcelExport={true}
                    gridOptions={
                      filterAppointment.length < 1 ? gridOptions2 : gridOptions
                    }
                  />
                )}
            </div>
          </div>
        </div>
      ) : (
          <AccessRightCard />
      )}
    </>
  );
};

export default DetailrevenueReports;
